import { getPrompts } from '../../api';
import { useListFetch } from '../../hooks';
import type { PromptsItem, GetPromptsFilters } from '../../api';
import type { PromptUpdatePayload, PromptCreatePayload } from '../../api';

export const usePrompts = (campaignId: string) => {
  return useListFetch<PromptsItem, GetPromptsFilters>(
    async params => {
      if (!params.filters?.campaignId) return { content: [], total: 0 };

      const result = await getPrompts(params?.filters, params?.pagination);
      return { content: result.items, total: result.total };
    },
    {
      initialPageSize: 50,
      initialFilters: { promptType: '', campaignId },
      withQueryParams: true,
      storageKey: 'use-prompts-list',
    }
  );
};

export type Item = PromptsItem;
export type FormType = Omit<Partial<PromptsItem>, 'model_params'> & {
  model_params?: string;
};
export type CreateItem = PromptCreatePayload;
export type UpdateItem = PromptUpdatePayload;
